import { DashboardNotification } from '@web/dashboard/types/DashboardNotification';
import { DashboardNotificationType } from '@web/dashboard/types';
import type { AnnouncementDashboardNotification } from '@web/announcements/types/AnnouncementDashboardNotification';

export const isAnnouncementDashboardNotification = (
  notification: DashboardNotification
): notification is AnnouncementDashboardNotification =>
  (notification as AnnouncementDashboardNotification).type ===
  DashboardNotificationType.announcementReceived;
